module.exports = __webpack_public_path__ + "static/media/neelesh_seerapu.d1f163b8.png";